<template>
  <div>
    <!-- 面包屑导航 -->
<!--    <el-breadcrumb separator-class="el-icon-arrow-right">-->
<!--      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>-->
<!--      <el-breadcrumb-item>行驶证年审费列表</el-breadcrumb-item>-->
<!--    </el-breadcrumb>-->
    <!-- 卡片 -->
    <el-card class="box-card" >
      <!-- 搜索  新增-->
      <el-form
          :inline="true"
          :model="searchForm"
          ref="searchForRef"
          autocomplete="on">
        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label="开始时间" size="small" label-width="70px">
              <el-date-picker v-model="searchForm.start_time" type="date"  placeholder="请选择开始时间"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="结束时间" size="small" label-width="70px">
              <el-date-picker v-model="searchForm.end_time" type="date"  placeholder="请选择结束时间"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="时间节点" size="small" label-width="70px">
              <el-select v-model="searchForm.type" filterable placeholder="请选择类型" >
                <el-option v-for="item in typeData" :label="item.name" :key="item.id" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label="关键字" size="small" label-width="70px">
              <el-input v-model="searchForm.keyword" placeholder="车主姓名|车牌号|运输公司" clearable type="text"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <shopCompanyTemp ref="shopCompanyTemp" @changeData="setshopId" ></shopCompanyTemp>
          </el-col>
          <el-col :span="1">
            <el-button size="small" type="success" @click="searchSubmit()">搜索</el-button>
            <!-- <el-button @click="searchRest()">重置</el-button> -->
          </el-col>
          <el-col :span="1">
            <el-button size="small" type="primary" @click="addData">新增</el-button>
          </el-col>
        </el-row>
      </el-form>

      <!-- 表格 -->
      <el-table ref="multipleTable" :data="tableLoadData" stripe border size="mini" :header-cell-style="{background:'#e5e5e5',color:'#333333'}" height="450">
        <el-table-column
            label="ID"
            min-width="5%"
            prop="id"
            :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column
            label="姓名"
            min-width="10%"
            prop="name"
            :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column
            label="车牌"
            min-width="10%"
            prop="plate_number"
            :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column
            label="车架"
            min-width="10%"
            prop="car_info.vin"
            :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column
            label="车型"
            min-width="10%"
            prop="car_info.model"
            :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column
            label="发证日期"
            min-width="10%"
            prop="car_info.issue_date"
            :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column
            label="注册日期"
            min-width="10%"
            prop="car_info.register_date"
            :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column
            label="性别"
            min-width="10%"
            :show-overflow-tooltip='true'>
          <template slot-scope="scope">{{ scope.row.sex | getSex }}</template>
        </el-table-column>

        <el-table-column
            label="出生年月"
            min-width="10%"
            :show-overflow-tooltip='true'>
          <template slot-scope="scope">{{ scope.row.birthday | dateFormat }}</template>
        </el-table-column>

        <el-table-column
            label="驾驶证号"
            min-width="10%"
            prop="drive_no"
            :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column
            label="领证时间"
            min-width="10%"
            :show-overflow-tooltip='true'>
          <template slot-scope="scope">{{ scope.row.reg_time | dateFormat }}</template>
        </el-table-column>
        <el-table-column
            label="驾龄"
            min-width="10%"
            prop="drive_age"
            :show-overflow-tooltip='true'></el-table-column>
        <el-table-column
            label="准驾车型"
            min-width="10%"
            prop="drive_type"
            :show-overflow-tooltip='true'></el-table-column>
        <el-table-column
            label="手机号"
            min-width="10%"
            prop="mobile"
            :show-overflow-tooltip='true'></el-table-column>
        <el-table-column
            label="参加工作时间"
            min-width="10%"
            prop="work_time"
            :show-overflow-tooltip='true'> <template slot-scope="scope">{{ scope.row.work_time | dateFormat }} </template></el-table-column>
        <el-table-column
            label="本次审核日期"
            min-width="10%"
            :show-overflow-tooltip='true'>
          <template slot-scope="scope">{{ scope.row.now_audit_time | dateFormat }}</template>
        </el-table-column>
          <el-table-column
              label="下次审核日期"
              min-width="10%"
              prop="next_time"
              :show-overflow-tooltip='true'>
            <template slot-scope="scope">{{ scope.row.next_audit_time | dateFormat }}</template>
        </el-table-column>
        <el-table-column
            label="单位或住址"
            min-width="10%"
            prop="address"
            :show-overflow-tooltip='true'></el-table-column>
        <el-table-column
            label="年检审记录"
            min-width="10%"
            prop="record"
            :show-overflow-tooltip='true'>
        </el-table-column>

        <el-table-column
            label="操作"

            width="130">
          <template slot-scope="scope">
            <el-button type="warning" size="mini" icon="el-icon-edit" @click="handelEdit(scope.row)"></el-button>
            <el-button type="danger" size="mini" icon="el-icon-delete" @click="handelDel(scope.row)"></el-button>
          </template>
        </el-table-column>

      </el-table>
      <!-- 分页 -->
      <div class="block" style="margin-top:10px">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 30, 100]"
          :page-size="limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </el-card>
    <!-- 新增编辑弹框 -->
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="70%">
      <el-form :model="form" :rules="rules" ref="form" label-width="110px">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="驾驶员姓名" prop="name"  size="small">
              <el-input v-model="form.name" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="性别" prop="" size="small">
              <el-select v-model="form.sex" filterable placeholder="请选择状态">
                <el-option v-for="item in sexData" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!--运输公司--><!--
          <el-col :span="12">
            <shopCompanyTemp ref="shopCompanyTemp"></shopCompanyTemp>
          </el-col>-->
        </el-row>

        <el-row :gutter="24">

          <el-col :span="12">
            <el-form-item label="出生年月" prop="" size="small">
              <el-date-picker v-model="form.birthday" type="date"  placeholder="选择日期"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="驾驶证号" prop="next_time"  size="small">
              <el-input v-model="form.drive_no" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="领证时间" prop="" size="small">
              <el-date-picker v-model="form.reg_time" type="date"  placeholder="选择日期"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="驾龄" prop="next_time"  size="small">
              <el-input v-model="form.drive_age" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="准驾车型" prop="" size="small">
              <el-input v-model="form.drive_type" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号" prop="next_time"  size="small">
              <el-input v-model="form.mobile" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="7">
            <carListTemp ref="carListTemp" :carId.sync="form.car_id" @changeData="setcarInfo"></carListTemp><!--车辆-->
          </el-col>
          <el-col :span="7">
            <el-form-item label="车主姓名" prop="" size="small">
              <el-input v-model="form.allPerson" autocomplete="off" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="参加工作时间" prop="" size="small">
              <el-date-picker v-model="form.work_time" type="date"  placeholder="选择日期"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="车架号" prop="" size="small">
              <el-input v-model="form.vin" autocomplete="off" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="车型" prop="" size="small">
              <el-input v-model="form.model" autocomplete="off" readonly></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="发证日期" prop="" size="small">
              <el-input v-model="form.issue_date" autocomplete="off" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="注册日期" prop="" size="small">
              <el-input v-model="form.register_date" autocomplete="off" readonly></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="本次审核日期" prop="next_time"  size="small">
              <el-date-picker v-model="form.now_audit_time" type="date"  placeholder="选择日期"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="下次审核时间" prop="" size="small">
              <el-date-picker v-model="form.next_audit_time" type="date"  placeholder="选择日期"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="单位或住址" size="small">
              <el-input v-model="form.address" type="textarea" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="年检审记录" prop="" size="small">
              <el-input v-model="form.record" type="textarea" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="reset_dialogForm('form')">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')">确 定</el-button>
      </div>
    </el-dialog>
    <!--
    <el-dialog title="图片" :visible.sync="uploadDialog" width="300px" style="line-height: 0;">
      <img style="width: 100%;height: 100%" :src="uploadImg" alt="" />
    </el-dialog>

    <eCar :carVisibleProp="isShowCar" v-on:eventCar="chooseCarInfo"/>
-->
  </div>
</template>

<script>
  //import eTable from "../common/eTable.vue";
  import moment from 'moment';    //日期时间转换
  import shopCompanyTemp from "../common/shopCompanyTemp.vue";
  import carListTemp from "../common/carlistTemp.vue";
  //import eCar from "../common/eCar";
  export default {
    name: "shipCompany",
    components: {
      //eTable,
      //eCar
      shopCompanyTemp,
      carListTemp
    },
    props: {},
    data() {
      return {
        isShowCar:false,
        // 搜索
        searchForm: {
          keyword:'',
          start_time:'',
          end_time:'',
          shop_id:'',
          type:''
        },
        searchRules: {
          keyword: [
            { required: true, message: "请输入车主姓名|车牌|运输公司", trigger: "blur" },
          ],
        },
        sexData:[
            {
              value:1,
              label:'男'
            },
            {
              value:2,
              label:'女'
            }],
        typeData:[
          {
            id:1,
            name:'代表30天内到期'
          },
          {
            id:2,
            name:'全部'
          }],
        // 数据
        tableLoadData: [],
        limit: 10,
        page:1,// 当前页码
        total:0,//总条目数
        id: '',
        rules: {
          next_audit_time: [{ required: true, message: '请输入下次审核时间', trigger: 'blur' }],
        },
        dialogFormVisible: false,
        title: '',
        form: {
          //allPerson:'',
          //plate_number:'',
          name:'',
          car_id:'',
          sex:'',
          birthday:'', //出生年月
          drive_no:'',//驾驶证号
          reg_time:'',//领证时间
          drive_age:'',//驾龄
          drive_type:'',//准驾车型
          mobile:'',//手机号
          work_time:'',//参加工作时间
          now_audit_time:'',//本次审核日期
          next_audit_time:'',//下次审核时间
          address:'',
          //shop_id:''
        },
        uploadImg: '',
        uploadDialog: false
      };
    },
    created() {
      this.DataList()
    },
    mounted() {

    },
    filters: {
      getSex(sex){
        if (sex == 1) {
          return "男";
        } else if (sex == 2) {
          return "女";
        }
      },
      statusFilter(status) {
        if (status == 1) {
          return "启用";
        } else if (status == 2) {
          return "禁用";
        }
      },
      //时间格式化
      dateFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("YYYY-MM-DD");
      },

    },
    methods: {
      setcarInfo(value){
        this.$set(this.form,'allPerson' , value.allPerson) //不用set 的形式，页面数据不更新
        this.form.vin = value.vin
        this.form.model = value.model
        this.form.issue_date = value.issue_date
        this.form.register_date = value.register_date
      },
      setshopId(value){
        //this.form.plate_number = value
        this.searchForm.shop_id = value
      },
      getTime (time) {
        var date = new Date(time)
        var y = date.getFullYear()
        var m = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
        var d = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())
        return y + '-' + m + '-' + d
      },
      chooseCar(){
        this.isShowCar=true;
        //console.log('dddd',this.isShowCar)
      },
      //接收子组件传过来的值
      chooseCarInfo(car_number,...params){
        this.searchForm.name=car_number;
      },
      DataList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          page: this.page,
          pageSize:this.limit
        }
        if(this.searchForm.type) param.type =  this.searchForm.type
        if(this.searchForm.shop_id) param.shop_id =  this.searchForm.shop_id
        if(this.searchForm.keyword) param.keyword =  this.searchForm.keyword
        if(this.searchForm.start_time) param.start_time =  this.getTime(this.searchForm.start_time)
        if(this.searchForm.end_time) param.end_time = this.getTime(this.searchForm.end_time)
        this.$axios.getDrivingLicence(param).then(res=>{
          if(res.code == 200){
            this.tableLoadData = res.data.data
            this.total = res.data.total
          }else{
            this.$message.error(res.msg);
          }
        }).catch(error=>{
          //console.log(error);
        })
      },
      // 设置每页条数
      handleSizeChange(newSize) {
        this.limit = newSize
        this.DataList()
      },
      // 分页跳转
      handleCurrentChange(newPage) {
        this.page = newPage
        this.DataList()
      },
      // 新增
      addData() {
        this.title = '新增'
        this.form = {
          // role_name: '',
        }
        this.dialogFormVisible = true
      },
      handelEdit(index,row) {
        this.id = index.id

        this.title = '编辑'
        this.form = {
        }
        this.dialogFormVisible = true
        // this.form = {...row};
        // 或者
        this.form = JSON.parse(JSON.stringify(index))

        this.form.now_audit_time = this.form.now_audit_time*1000
        this.form.work_time = this.form.work_time*1000
        this.form.next_audit_time = this.form.next_audit_time*1000
        this.form.birthday = this.form.birthday*1000
        this.form.reg_time = this.form.reg_time*1000
      },

      reset_dialogForm(formName) {
        this.dialogFormVisible = false
        this.$nextTick(() => {
          this.$refs[formName].resetFields()
        })
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            const param = {
              car_id: this.$refs.carListTemp.form.car_id,//this.form.car_id,
              //shop_id: this.$refs.shopCompanyTemp.form.shop_id,//this.form.shop_id,
              name:this.form.name,
              sex:this.form.sex,
              birthday:this.getTime(this.form.birthday),
              drive_no:this.form.drive_no,
              reg_time:this.getTime(this.form.reg_time),
              drive_age:this.form.drive_age,
              drive_type:this.form.drive_type,
              work_time:this.getTime(this.form.work_time),
              now_audit_time:this.getTime(this.form.now_audit_time),
              next_audit_time:this.getTime(this.form.next_audit_time),
              address:this.form.address,
              //allPerson:this.form.allPerson,
              mobile:this.form.mobile,
              record:this.form.record,
              //plate_number:this.form.plate_number,
              operator_id: sessionStorage.getItem('user_id'),
              company_id:sessionStorage.getItem('company_id'),
              access_token:sessionStorage.getItem('token')
            }
            if(this.id) param.id = this.form.id
            this.$axios.saveDrivingLicence(param).then(res =>{
              if(res.code == 200){
                this.DataList()
                this.$message.success(res.msg)
                this.dialogFormVisible = false
              }else{
                this.$message.error(res.msg);
              }
            })
          }
        })
      },
      searchSubmit() {
        this.page = 1
        this.DataList()
      },

      handelDel(e) {
        this.$confirm('此操作将删除该运输公司, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const param = {
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token'),
            id: e.id,
          }
          //console.log(param);

          this.$axios.delDrivingLicence(param).then(res=>{
            if(res.code == 200){
              this.$message.success(res.msg);
              this.DataList()
            }else{
              this.$message.error(res.msg);
            }
          }).catch(error=>{
            //console.log(error);
          })
        }).catch(() => {
          // 点击取消:不删除了
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
          this.DataList()
        });
        this.teamDialog = false
      },
      // 点击弹出当前的图片
      handelDialog(index) {
        this.uploadDialog = true
        this.uploadImg = index.row.file_url.local_file_path
      }

    },
  };
</script>
<style>
  .table_name{
    font-weight: bold;
    /* border: 1px solid #f00; */
  }
  .table_name:hover{
    color: #409EFF;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/view/fee/drivingFeeList.vue